import { useEffect, useRef, useState } from "react";
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";
import { PDFDocumentProxy } from "pdfjs-dist";
import React from "react";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface RBPdfProps {
  fileUrl: string;
  height?: number;
  // When true, each page is sized to fill the container's width (responsive),
  // ignoring `height`. Use this for full previews so pages aren't tiny in a
  // wide modal. Leave off for small fixed-height inline thumbnails.
  fitWidth?: boolean;
}
export const RBPdf: React.FC<RBPdfProps> = ({ fileUrl, height, fitWidth }) => {
  // Track the total page count and render EVERY page (stacked vertically) so
  // multi-page PDFs are fully visible — the caller's container provides scroll.
  // Previously this rendered a single <Page> whose number was set to the page
  // count, so a 2-page PDF showed only the last page and was not scrollable.
  const [numPages, setNumPages] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState<number | undefined>(undefined);

  const onDocumentLoadSuccess = ({ numPages: nextNumPages }: PDFDocumentProxy) => {
    setNumPages(nextNumPages);
  };

  // In fit-width mode, measure the container so each page fills its width and
  // stays responsive (e.g. as the modal/window resizes).
  useEffect(() => {
    if (!fitWidth) {
      return undefined;
    }
    const element = containerRef.current;
    if (!element) {
      return undefined;
    }
    const updateWidth = () => setContainerWidth(element.clientWidth);
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, [fitWidth]);

  return (
    <div ref={containerRef} style={{ width: "100%" }}>
      <Document
        file={fileUrl}
        onLoadError={console.error}
        onLoadSuccess={onDocumentLoadSuccess}
      >
        {Array.from(new Array(numPages), (_element, index) => (
          <div
            key={`page_${index + 1}`}
            style={{ display: "flex", justifyContent: "center", marginBottom: 12 }}
          >
            <Page
              pageNumber={index + 1}
              width={fitWidth ? containerWidth : undefined}
              height={fitWidth ? undefined : height}
            />
          </div>
        ))}
      </Document>
    </div>
  );
};
